import { Dispatch } from 'redux';
import { ActionType, SearchActionType } from '../search/types';
import { AssignmentAPI } from '../../api/assignment-api';
import { dispatchError } from '../search/actions'; 

export const listcourse= (classId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_LOADING
    });
    AssignmentAPI.listCourse(classId).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_LOADED,
            payload: response.data,
            table: "list_course",
            page: "assignment",
            action: ActionType.QUERY
        });
    }, function (error) {
       dispatchError("assignment",dispatch,error);
    })
};

export const listtrainer= (classId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_LOADING
    });
    AssignmentAPI.listTrainer(classId).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_LOADED,
            payload: response.data,
            table: "list_trainer",
            page: "assignment",
            action: ActionType.QUERY
        });
    }, function (error) {
       dispatchError("assignment",dispatch,error);
    })
};

export const getassignment= (classId: number,classStudentId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_LOADING
    });
    AssignmentAPI.get(classId,classStudentId).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_LOADED,
            payload: response.data,
            table: "assignment",
            page: "assignment",
            action: ActionType.QUERY
        });
    }, function (error) {
       dispatchError("assignment",dispatch,error);
    })
};

export const saveassignment = (item: any) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_UPDATING
    });
    AssignmentAPI.save(item).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_UPDATED,
            payload: response.data,
            table: "assignment",
            page: "assignment",
            action: ActionType.UPDATE
        });
    }, function (error) {
        if ((error.response!==undefined) && (error.response.status===400)) {
            dispatch({
                type: SearchActionType.QUERY_ERROR,
                page: "assignment",
                payload: error.response.data.additional
            });
        } else 
            dispatchError("assignment",dispatch,error);
    })
};

export const listfeedback= (classId: number,classStudentId: number) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SearchActionType.QUERY_LOADING
    });
    AssignmentAPI.listFeedback(classId,classStudentId).then(function (response) {
        dispatch({
            type: SearchActionType.QUERY_LOADED,
            payload: response.data,
            table: "list_feedback",
            page: "assignment",
            action: ActionType.QUERY
        });
    }, function (error) {
       dispatchError("assignment",dispatch,error);
    })
};

